import React from 'react';
import { Button } from '@mui/material';
import { PictureAsPdf as PdfIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { shouldDisableExportPdfButton } from '../utils/exportPdfButton';
import { exportItemTableToPdf } from '../utils/exportToPdf';

export default function ExportPdfButton({
  exportConfig,
  disabled,
  label,
  size = 'small',
  variant = 'outlined',
  sx,
}) {
  const { t } = useTranslation();

  const handleClick = () => {
    if (exportConfig) {
      exportItemTableToPdf(exportConfig).catch((err) => {
        console.error('PDF export failed', err);
      });
    }
  };

  return (
    <Button
      size={size}
      variant={variant}
      startIcon={<PdfIcon />}
      onClick={handleClick}
      disabled={shouldDisableExportPdfButton({ disabled, exportConfig })}
      sx={sx}
    >
      {label ?? t('export.pdfButton')}
    </Button>
  );
}
